import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { PureAbility } from '@casl/ability';

export const AbilityContext = createContext<PureAbility<any, any>>(new PureAbility());
export const Can = createContextualCan(AbilityContext.Consumer);

const ability = new PureAbility();

export default ability;